import { State as MetadataState } from '@client/reducers/metadata-reducer';
import { Selector } from '@ngrx/store';
export const getRefreshUser: Selector<MetadataState, string> = (state: MetadataState) => state.refreshUser;
